import { UploadEvent, FileSystemFileEntry } from 'ngx-file-drop';
import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'browse-file',
  templateUrl: './browse-file.component.html',
  styleUrls: ['./browse-file.component.sass']
})
export class BrowseFileComponent implements OnInit, OnChanges {
  constructor() { }

  @Output()
  fileSelected: EventEmitter<any> = new EventEmitter();

  @Input()
  result: { valid: boolean, message: string };

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    this.result = changes.result.currentValue;
  }

  /**
   * Emit the droped file from UI
   * @param event
   */
  public dropped(event: UploadEvent) {
    for (const droppedFile of event.files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          this._emitSelectedFile(file);
        });
      }
    }
  }

  /**
   * Triger the click event for file-input
   */
  public openFileBrowser() {
    document.getElementById('file-input').click();
  }

  /**
   * Emit file on fileSelected event
   * @param fileSelected
   */
  public onFileSelected(fileSelected) {
    var files = fileSelected.target.files;
    for (const file of files) {
      this._emitSelectedFile(file);
    }
  }

  private _emitSelectedFile(file) {
    this.fileSelected.emit(file);
  }
}
